import React from 'react';

function SpotifyPlayer(props) {

    return (
        <iframe title="Listen on Spotify" src={props.src} width="100%" height={props.height} frameBorder="0" allowtransparency="true" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
        );

}export default SpotifyPlayer